import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useInView } from 'react-intersection-observer';
import { Throbber } from '@lt/components';

import { PAGINATION } from '../../../../store/hotels/constants';

import type { PropsFromRedux } from './index';

export const ShowMoreHotels = (props: PropsFromRedux): JSX.Element | null => {
  const { ref, inView } = useInView();
  const [isLock, setIsLock] = useState(false);

  const {
    hotelsVisibleLimit,
    setVisibleHotels,
    isAwaitingFiltration,
    isVisible,
  } = props;

  useEffect(() => {
    if (inView && !isLock && !isAwaitingFiltration && isVisible) {
      setIsLock(true);
      setVisibleHotels(hotelsVisibleLimit + PAGINATION.VISIBLE_LIMIT);
    }

    if (!inView) {
      setIsLock(false);
    }
  }, [
    setVisibleHotels,
    hotelsVisibleLimit,
    inView,
    isLock,
    isAwaitingFiltration,
    isVisible,
  ]);

  if (!isVisible) {
    return null;
  }

  return (
    <ThrobberContainer ref={ref}>
      <Throbber color="gray" />
    </ThrobberContainer>
  );
};

const ThrobberContainer = styled.div`
  position: relative;
  height: 100px;
`;
